import { FinanceiroConfiguracoesScreen } from "@/screens/financeiro/configuracoes";

export function FinanceiroConfiguracoesPage() {
  return <FinanceiroConfiguracoesScreen />;
}
